import { UrlsEnum } from '@lentau/ui-kit/core/enums/route.enum';
import { WebPlatform } from '@lentau/ui-kit/core/enums/web-platform.enum';
import { getWebviewPlatformByLocation } from '@lentau/ui-kit/core/helpers/web-platform/web-platform.helper';

/** SEM `sem/redirect` body.status: правила редиректа нет */
export const SEM_REDIRECT_STATUS_NO_RULE: number = 0;

const getWebPlatformFromUrlQuery: (urlWithSearch: string) => string | null = (urlWithSearch: string): string | null => {
  const queryStartIndex: number = urlWithSearch.indexOf('?');
  if (queryStartIndex < 0) {
    return null;
  }

  const hashStartIndex: number = urlWithSearch.indexOf('#', queryStartIndex);
  const search: string =
    hashStartIndex >= 0 ? urlWithSearch.slice(queryStartIndex, hashStartIndex) : urlWithSearch.slice(queryStartIndex);

  return getWebviewPlatformByLocation({ search } as Location);
};

/** Редирект на home только при `?web_platform=okey_web` в текущем URL (не из cookie). */
export const shouldRedirectOkeyWebToHome: (
  status: number,
  urlWithSearch: string,
  pathname: string,
  isLentaBrand: boolean
) => boolean = (status: number, urlWithSearch: string, pathname: string, isLentaBrand: boolean): boolean => {
  return (
    isLentaBrand &&
    status === SEM_REDIRECT_STATUS_NO_RULE &&
    getWebPlatformFromUrlQuery(urlWithSearch) === WebPlatform.OKEY_WEB &&
    pathname !== UrlsEnum.Base
  );
};
